<!--
 * @Author: 张家林
 * @LastEditors: 张家林
-->
<template>
  <div>
    <a href="https://v.youku.com/v_show/id_XMzk0NzY1NzM2MA=="><span class="video">视频地址</span></a>
    <img src="../assets/gantong.jpg" alt="" width="100%">
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
a {
  position: absolute;
  color: #000;
  width: 100%;
  height: 100px;
  z-index: 99;
  text-align: center;
  top: 180px;
  span {
    font-size: 16px;
    text-decoration: underline;
    color: rgb(0, 140, 255);
  }
}
</style>

